import { render } from "./ManualDiscount.vue?vue&type=template&id=7525774a"
import script from "./ManualDiscount.vue?vue&type=script&lang=js"
export * from "./ManualDiscount.vue?vue&type=script&lang=js"

import "./ManualDiscount.vue?vue&type=style&index=0&id=7525774a&lang=scss"
script.render = render

export default script